module.exports = "../dist/img/mini-22.6f03.jpg";